import { FC } from "react";
import { MuiModal } from "../../../../components/modal/MuiModal";
import { useSiteCore } from "../../../../hooks/useSiteCore";
import { MuiTypography } from "../../../../components/typography/MuiTypography";
import { DiscardMessageWrapper } from "../createProgramTemplateFooter/CreateProgramTemplateFooter.style";
import { createProgramSiteCoreKeys } from "../../siteCore/SiteCoreKeys";

interface DurationWarningModalProps {
  showModal: boolean;
  handleModalClose: () => void;
  label?: string;
}
export const DurationWarningModal: FC<DurationWarningModalProps> = ({
  handleModalClose,
  showModal,
  label,
}) => {
  const { commonLabels, fetchLabel } = useSiteCore();
  return (
    <MuiModal
      open={showModal}
      onClose={handleModalClose}
      title={commonLabels.warning}
      primaryButtonTitle={commonLabels.ok}
      onPrimaryButtonClick={handleModalClose}
    >
      <DiscardMessageWrapper>
        <MuiTypography
          id="modal-description"
          variant="h3"
          className="confirm-message"
          data-testid="duration-warning-modal"
        >
          {label ??
            fetchLabel(
              createProgramSiteCoreKeys.compatibleTemplateKey,
              createProgramSiteCoreKeys.durationAlertMessage,
            )}
        </MuiTypography>
      </DiscardMessageWrapper>
    </MuiModal>
  );
};
